import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import styles from '../../../styles/uitk-egds-badge.css';
import { EGDSBadgeSize } from '../../types/index.esm.js';
import { classNames } from '../../../utils/classnames/index.esm.js';
import { validatePropType } from '../../../utils/validate-prop-types/index.esm.js';
const getClassNameList = classNames.bind(styles);
/**
 * @deprecated EGDSBadge and EGDSBadgeTheme should not be used. Use one themes from the specific badge type from the specific badge types instead like `EGDSBadgeStandardTheme`
 */
var EGDSBadgeTheme;
(function (EGDSBadgeTheme) {
  EGDSBadgeTheme["DEAL_BUNDLED"] = "deal-bundled";
  EGDSBadgeTheme["DEAL_GENERIC"] = "deal-generic";
  EGDSBadgeTheme["DEAL_MEMBER"] = "deal-member";
  EGDSBadgeTheme["NOTIFICATION_1"] = "notification-1";
  EGDSBadgeTheme["NOTIFICATION_2"] = "notification-2";
  EGDSBadgeTheme["VIP"] = "vip";
  EGDSBadgeTheme["LOYALTY_EXTRA_HIGH_TIER"] = "loyalty-extra-high-tier";
  EGDSBadgeTheme["LOYALTY_HIGH_TIER"] = "loyalty-high-tier";
  EGDSBadgeTheme["LOYALTY_MIDDLE_TIER"] = "loyalty-middle-tier";
  EGDSBadgeTheme["LOYALTY_LOW_TIER"] = "loyalty-low-tier";
  EGDSBadgeTheme["SPONSORED"] = "sponsored";
  EGDSBadgeTheme["PROMOTED"] = "promoted";
  EGDSBadgeTheme["VIEWED"] = "viewed";
  EGDSBadgeTheme["SAVED"] = "saved";
  EGDSBadgeTheme["FAMILY_FRIENDLY"] = "family-friendly";
  EGDSBadgeTheme["SUPPLIER_PROMO"] = "supplier-promo";
})(EGDSBadgeTheme || (EGDSBadgeTheme = {}));
/**
 * @deprecated do not use. Use one of the specific badge types instead `EGDSBadgeStandard, EGDSBadgeLoyalty, EGDSBadgeNotification, EGDSBadgeProgram`
 */
class EGDSBadge extends React.Component {
  static displayName = 'EGDSBadge';
  static defaultProps = {
    size: EGDSBadgeSize.LARGE,
    theme: EGDSBadgeTheme.DEAL_GENERIC
  };
  static baseClassName = 'uitk-badge';
  render() {
    const {
      a11yText,
      className,
      children,
      text,
      size,
      theme
    } = this.props;
    const wrapperClassNames = getClassNameList('uitk-badge', {
      [`${EGDSBadge.baseClassName}-${size}`]: validatePropType(size, EGDSBadgeSize)
    }, {
      [`${EGDSBadge.baseClassName}-${theme}`]: validatePropType(theme, EGDSBadgeTheme)
    }, {
      [`${EGDSBadge.baseClassName}-has-text`]: text
    }, className);
    return jsxs("span", {
      className: wrapperClassNames,
      children: [children, text && jsx("span", {
        className: getClassNameList(`${EGDSBadge.baseClassName}-text`),
        "aria-hidden": !!a11yText,
        children: text
      }), a11yText && jsx("span", {
        className: "is-visually-hidden",
        children: a11yText
      })]
    });
  }
}
export { EGDSBadge, EGDSBadgeTheme };